export const mapToMenuColumnsLayout = (menuColumnsCount: number) => {
    switch (menuColumnsCount) {
        case 3:
            return 'three';
        case 4:
            return 'four';
        case 5:
            return 'five';
        default:
            throw new Error(`Unsupported menu columns count: ${menuColumnsCount}`);
    }
};
